import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Card = styled.div`
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.md};
  box-shadow: ${theme.shadows.small};
  border: 1px solid ${theme.colors.softGray};
`;
